export default "__VITE_ASSET__MgfQdIxg__"